import React from "react";

function SectionHead({ title, description }) {
  return (
    <div className="w-full space-y-2">
      <h1 className="text-center text-[clamp(2rem,2vw+1rem,2.2rem)]">
        {title}
      </h1>
      <p className="text-gray-500 text-[clamp(0.9rem,2vw+0.8rem,1rem)] text-center">
        {description}
      </p>
    </div>
  );
}

export default SectionHead;
